module.exports = __webpack_public_path__ + "img/lenders.2314b619.svg";